<template>

  <div :class="{row: this.buttonsDef.length}" v-if="render">
    <div :class="{'col-sm-8': this.buttonsDef.length}">
      <div class="form-group input-multiple-select" :data-code="element.code">
        <label :title="tooltip(element.label)">
          {{ t(element.label) }}
          <icons-render v-if="element.icons" :propIcons="element.icons"/>
        </label>
        <div
          v-if="!element.readonly && values.length"
          @click="_clear"
          class="input-multiple-select-clear">
          <i class="fa fa-close"></i>
        </div>
        <select
          ref="element"
          multiple="multiple"
        >
        </select>
        <div class="clearfix"></div>
      </div>
    </div>
    <div v-if="this.buttonsDef.length" class="col-sm-4 pl-0 form-element-button-wrapper">
      <form-action-button
        :def="def"
        :buttonsDef="buttonsDef"
        :updateDataRequest="updateDataRequest"
        :formDataChanged="formDataChanged"/>
    </div>
  </div>

</template>

<script>
import IconsRender              from '../../templates/widgets/icons-render'
import FormActionButton         from '../../widgets/forms/form-action-button'
import FormElementButtonsHelper from '../../../model/helper/forms/form-element-buttons-helper'
import SourceLoader             from '../../../model/loader/source-loader'
import DictionaryLoader         from '@/model/loader/dictionary-loader'

export default {
  name:       'multiselect',
  components: {
    FormActionButton,
    IconsRender
  },
  props:      {
    def:               {
      type:    Object,
      default: () => {
        return {}
      }
    },
    element:           {
      required: true,
      type:     Object,
      default:  () => {
        return {
          name:     null,
          type:     null,
          dataType: null,
          label:    null,
          source:   {
            required: true,
            type:     Object,
            default:  () => {
              return {}
            }
          },
          items:    {
            type:    Array,
            default: () => {
              return []
            }
          }
        }
      }
    },
    ownValue:          {
      type:    Boolean,
      default: false
    },
    updateDataRequest: {
      type:    Function,
      default: null
    },
    formDataChanged:   {
      type:    Function,
      default: null
    },
    defaultValue:      {
      type:    Object,
      default: null
    }
  },

  data () {
    return {
      textValue:      null,
      values:         [],
      options:        [],
      selectedValues: [],

      callApi:      false,
      buttonsDef:   [],
      responseData: [],
      $element:     null,
      render:       true
    }
  },

  mounted () {
    this.buttonsDef = FormElementButtonsHelper.getButtonsDef(this.element)
  },

  methods: {
    _initElement () {
      if (!this.$element) {
        this.$element = $(this.$refs.element)
        this.$element.select2({
          width:             '100%',
          closeOnSelect:     false,
          disabled:          this.element.readonly,
          language: {
            noResults: () => {
              return this.$translate.text('no_results_found')
            }
          },
          templateSelection: (e) => {
            const selected = this.findItem(e.id)
            let badge      = ''
            if (selected) {
              badge = '<span class="' + selected.option_badge.IconClass + ' ' + selected.option_badge.ValueClass + '"></span>'
            }
            return $('<span>' + e.text + '</span>' + badge)
          },
          templateResult:    (filteredOption) => {
            if (filteredOption.hasOwnProperty('disabled')) {
              return filteredOption.text
            }

            let content = '<span>' + filteredOption.text + '</span>'
            const item  = this.findItem(filteredOption.id)
            if (item) {
              const optionBadge = item.option_badge
              const spanClass   = optionBadge.IconClass + ' ' + optionBadge.ValueClass
              content           = content + '<span class="' + spanClass + '"></span>'
            }

            return $(content)
          },
          ajax:              {
            transport: (params, success, failure) => {
              // if (!params.data.hasOwnProperty('term') || !params.data.term) {
              //   success({ results: [] })
              //   return
              // }

              let source        = this.element.source
              source.defaults   = this.$parent.innerValues ? this.$parent.innerValues.getValuesTransformed() : {}
              source.searchText = params.data.term
              source.def        = this.def

              const callback = (i, responseData) => {
                const options = []
                for (let option of responseData) {
                  let newOption = {}
                  Object.keys(option).forEach(function (item) {
                    let value = option[item]

                    if (item === 'OPTION_BADGE') {
                      value = JSON.parse(option[item])
                    }

                    newOption[item.toLowerCase()] = value
                  })
                  options.push(newOption)
                }

                this.options = options
                const items  = []

                for (let item of this.options) {
                  items.push({ id: item.option_value, text: item.option_text })
                }

                success({ results: items })
              }

              SourceLoader.load(source, callback)
            }
          }
        })
        this.$element.on('change', () => {
          this.values = this.$element.val()
          this.$element.parent().find('.select2-search__field').val('')

          this.setupSelectedValues()
          this._changeValue()
        })
        this.$element.on('select2:select', () => {
          this._blur()
        })
        this.$element.on('select2:unselect', () => {
          this._blur()
        })
        this.$element.on('select2:clear', () => {
          this._blur()
        })
      }
    },

    _changeValue () {
      const value = this.selectedValues.length ? JSON.stringify(this.selectedValues) : null
      const args  = { element: this.element, value: value }
      this.$emit('changeValue', args)
    },

    _blur () {
      const value = this.selectedValues.length ? JSON.stringify(this.selectedValues) : null
      const args  = { element: this.element, value: value }
      this.$emit('blur', args)
    },

    updateValue (values) {
      if (values.value) {
        this.values         = []
        this.selectedValues = []

        this.selectedValues = JSON.parse(values.value)
        for (let selectedValue of this.selectedValues) {
          this.values.push(selectedValue.option_value)

          for (const key in this.options) {
            if (this.options[key].option_value === selectedValue.option_value) {
              this.options.splice(key, 1)
            }
          }
          this.options.push(selectedValue)
        }
      }
      else {
        this.values         = []
        this.selectedValues = []
      }

      this._initElement()

      if (this.values.length) {
        this.$element.empty()
        for (let selectedValue of this.selectedValues) {
          const newOption = new Option(selectedValue.option_text, selectedValue.option_value, false, false)
          this.$element.append(newOption)
        }
      }
      this.$element.val(this.values)
      this.$element.trigger('change')
    },

    _clear () {
      this.values         = []
      this.selectedValues = []
      this.$element.val(null).change()

      this._changeValue()
      this._blur()
    },

    findItem (id) {
      for (const option of this.options) {
        if (option.option_value.toString() === id.toString()) {
          return option
        }
      }

      for (const option of this.selectedValues) {
        if (option.option_value.toString() === id.toString()) {
          return option
        }
      }

      return null
    },

    setupSelectedValues () {
      const originals = []
      this.selectedValues.map((item) => {
        originals.push(item)
      })

      this.selectedValues = []

      this.values.map((item) => {
        this.options.map((option) => {
          if (option.option_value.toString() === item) {
            this.selectedValues.push(option)
          }
        })
      })

      this.values.map((item) => {
        for (const option of this.selectedValues) {
          if (option.option_value.toString() === item) {
            return
          }
        }

        originals.map((option) => {
          if (option.option_value.toString() === item) {
            this.selectedValues.push(option)
          }
        })
      })
    },

    setRender (render) {
      this.render = render
    },

    tooltip (key) {
      return DictionaryLoader.tooltip(key, this.$user.languageCode)
    }
  }
}
</script>

<style>

.select2-selection__choice .icon {
  margin-left: 4px;
}

.input-multiple-select .selected-value {
  background: #e4eaec;
  padding: 5px 10px;
  border-radius: .215rem;
  margin-right: 3px;
}

.input-multiple-select .selected-value .content {
  color: #37474f;
  font-weight: bold;
}

.input-multiple-select-clear {
  display: inline-block;
  float: right;
  cursor: pointer;
}

.select2-container .select2-results__option[aria-selected=true] {
  position: relative;
  /*background: #fff;*/
}

.select2-container--default .select2-results__option {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.select2-container--default .select2-results__option--highlighted {
  background-color: #d5d7d8 !important;
}

.select2-container--default .select2-results__option[aria-selected=true]:after {
  content: "\2714";
  position: absolute;
  right: 15px;
}

.select2-container--default .select2-results__option span.icon {
  margin-right: 30px;
}

.select2-container--default .select2-selection--multiple .select2-selection__choice {
  color: #37474f;
  font-weight: 500;
  font-size: 1rem;
}

</style>
